import { ReactElement } from "react";
import { useEffect, useState } from "react";
import * as skTypes from "../../../types/sk";
import * as utils from "../../../util/skUtils";
import { useAppSelector } from "../../../state/store";
import "../QuizSite.scss";

interface ShowTeamProps {
  boxScore: skTypes.BoxScore;
  teams: skTypes.Team[];
  onClose: () => void;
  reverse: boolean;
}

/**
 * A large-text view to show the team the score
 */
export function ShowTeam(props: ShowTeamProps) {
  const { skAdvanced } = useAppSelector((state) => state.settings);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    // close on click, but wait to fire the event until the thing has actually loaded
    if (rendered) window.addEventListener("click", props.onClose);
    if (!rendered) setRendered(true);
    return () => window.removeEventListener("click", props.onClose);
  });

  const getTeamScoreDisplay = (): ReactElement[] => {
    const result: ReactElement[] = props.boxScore.teams.map((team, index) => {
      let bonusPotential: boolean = false;
      if (team.quizzersAnswering >= 4) {
        team.lineup.forEach((quizzerId, quizzerIndex) => {
          const quizzer = team.quizzers[quizzerId];
          if (
            utils.isQuizzerEligable(props.boxScore, index, quizzerIndex) &&
            quizzer.points === 0
          )
            bonusPotential = true;
        });
      }

      const quizTeam = props.teams[index];
      return (
        <div
          key={team.teamId}
          style={{
            width: `calc((100% / ${props.teams.length}) - 2px)`,
            padding: 10,
            textAlign: "center",
          }}
        >
          <div
            className="no-wrap-text"
            style={{
              fontSize: 48,
              color:
                bonusPotential &&
                team.eligable &&
                skAdvanced &&
                props.boxScore.quizStatus !== "ENDED"
                  ? "green"
                  : undefined,
            }}
          >
            {quizTeam.nickname || quizTeam.teamName}
          </div>
          <div
            className={
              team.eligable &&
              skAdvanced &&
              props.boxScore.quizStatus !== "ENDED"
                ? `${
                    team.errors >= 3
                      ? team.errors >= 6
                        ? "high-errors-show"
                        : "middle-errors-show"
                      : ""
                  }`
                : ""
            }
            style={{
              fontSize: "min(160px, max(12vw, 100px))",
              textAlign: "center",
            }}
          >
            {team.points}
          </div>
        </div>
      );
    });
    if (props.reverse) {
      return result;
    } else {
      return result.reverse();
    }
  };
  return (
    <div
      className="page"
      style={{ paddingTop: "20vh", minWidth: 850, display: "flex" }}
    >
      {getTeamScoreDisplay()}
    </div>
  );
}
